import { Injectable } from '@angular/core';
import { Breakpoint, BreakpointEnum } from '@fleet-beat/core';
import { BehaviorSubject, fromEvent, map, startWith, distinctUntilChanged, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private breakpointSubject: BehaviorSubject<Breakpoint> = new BehaviorSubject<Breakpoint>(
    this.calculate(window.innerWidth),
  );

  listenBreakpoints(): Observable<Breakpoint> {
    return this.breakpointSubject.asObservable().pipe(distinctUntilChanged());
  }

  getInstantBreakpoint(): Breakpoint {
    return this.breakpointSubject.getValue();
  }

  initListener(): void {
    fromEvent(window, 'resize')
      .pipe(
        map(() => window.innerWidth),
        startWith(window.innerWidth),
        map((width: number) => this.calculate(width)),
        distinctUntilChanged(),
      )
      .subscribe((bp: Breakpoint) => this.breakpointSubject.next(bp));
  }

  private calculate(width: number): Breakpoint {
    if (width <= 640) return BreakpointEnum.XS;
    if (width <= 768) return BreakpointEnum.SM;
    if (width <= 1000) return BreakpointEnum.MD;
    return BreakpointEnum.XL;
  }
}
